<template>
  <div v-if="show" class="alert" :class="`alert--${type}`">
    <div class="alert__title">{{ type }}</div>
    <div class="alert__description">
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-alert',
  props: {
    description: {
      required: true,
      type: String,
    },
    show: {
      required: false,
      type: Boolean,
      default: false,
    },
    type: {
      required: true,
      validator: value => {
        return ['success', 'error', 'warning'].includes(value);
      },
    },
  },
};
</script>
